// Owner, 2026-09-03: "instead of requiring the user to select stay logged in, can the system
// just auto refresh the tokens?" — yes. The old interval showed the Session Expiring Soon modal
// at T-10min, BEFORE the T-5min silent-refresh branch could act, prompting humans to do by hand
// what the next tick would have done automatically. This policy makes silent refresh the answer
// whenever a refresh token exists; the modal survives ONLY as the emergency path (no refresh
// token to use, or a refresh that actually failed) — a warning the operator genuinely must see.
//
// Pure on purpose: ApiClient.js imports axios (ESM, untransformable by CRA Jest — the two
// long-failing suites), so the decision logic lives here where it can be tested.

/** How the token-watch interval should react to the current token state. */
export function sessionRefreshDecision({ timeUntilExpiry, hasRefreshToken, warningShown }) {
    if (timeUntilExpiry == null || Number.isNaN(timeUntilExpiry)) return 'NONE';

    // Expired or inside the 10-minute window: silently refresh whenever we hold the means to.
    // One branch, one threshold — the old 5-vs-10-minute split is what let the modal outrun
    // the refresh.
    if (timeUntilExpiry <= 600) {
        if (hasRefreshToken) return 'REFRESH';
        // No refresh token: the modal is the truth — but say it once, not every tick.
        return warningShown ? 'NONE' : 'WARN';
    }

    return 'NONE';
}
